import { cart } from '@services';
import { notyf } from '@modules';
import { QuantityInput } from './quantity-input.js';

class CustomQuantityInput extends QuantityInput {
  async _publishQuantityChange() {
    const newQuantity = parseInt(this._input.value);
    const lineItem = this.closest('line-item');
    const lineItemKey = lineItem?.dataset.lineItemKey;
    const loadingOverlay = lineItem?.querySelector('.loading-overlay');

    if (!lineItemKey) return;

    if (loadingOverlay) loadingOverlay.ariaHidden = 'false';

    try {
      const cartData = await cart.get();
      const updates = {};

      for (const item of cartData.items) {
        if (item.key === lineItemKey) {
          updates[item.key] = newQuantity;
        } else if (item.parent_relationship?.parent_key === lineItemKey) {
          updates[item.key] = newQuantity;
        }
      }

      if (Object.keys(updates).length > 0) {
        await cart.update({ updates });
      }
    } catch (error) {
      notyf.error(error.message);
    } finally {
      if (loadingOverlay) loadingOverlay.ariaHidden = 'true';
    }
  }
}

customElements.define('custom-quantity-input', CustomQuantityInput);
